import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap-libs/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  /* prettier-ignore */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  /* prettier-ignore */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
    font-size: 16px;
  }
  ol,
  ul {
    list-style: disc;
    list-style-position: inside;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  [role="button"] {
    cursor: pointer;
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 8px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.colors.input};
    border-radius: 10px;
  }
  *, html, body, a, p, div, span, b, i {
    font-family: 'Roboto Mono', sans-serif;
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }

  #bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 0;
  }

  .home-page {
    background-image: url('/images/despair/despair-bg.png'), url('/images/despair/mirror.png'), url('/images/despair/bg.jpg');
    background-repeat: no-repeat;
    background-size: auto 66%, auto 90%, cover;
    background-position: bottom left, bottom right, center;
  }

  .gray-kingdom-page {
    background-image: url('/images/despair/bg-gk-despair-1.png'), url('/images/despair/bg-gk-mirror.png'), url('/images/despair/bg-gk.jpg');
    background-repeat: no-repeat;
    background-position: left bottom, left bottom, center;
    background-size: auto 100%, auto 100%, cover;
}

  .endless-page {
    background-image: url('/images/despair/bg-endless.svg');
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: cover;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    .home-page {
      background-position: 256px bottom, right bottom, center;
      background-size: 33% auto, auto 90%, cover;
    }
  
    .gray-kingdom-page {
      background-image: url('/images/despair/bg-gk-l1.png'), url('/images/despair/bg-gk-l2.png'), url('/images/despair/bg-gk-l3.png'), url('/images/despair/bg-gk-despair-1.png'), url('/images/despair/bg-gk-despair-2.png'), url('/images/despair/bg-gk-mirror.png'), url('/images/despair/bg-gk.jpg');
      background-repeat: no-repeat;
      background-position: center, center, center, 256px bottom, right bottom, 256px bottom, center;
      background-size: cover, cover, cover, auto 100%, auto 100%, auto 100%, cover;
    }
  }  
`

export default GlobalStyle
